var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddItemIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8025",
    "data-name": "Group 8025",
    transform: "translate(-1643 -115)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2076",
    "data-name": "Ellipse 2076",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(1643 115)",
    fill: "#734bd1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8024",
    "data-name": "Group 8024",
    transform: "translate(45.5 17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_1353",
    "data-name": "Line 1353",
    d: "M32,3H0A3,3,0,0,1-3,0,3,3,0,0,1,0-3H32a3,3,0,0,1,3,3A3,3,0,0,1,32,3Z",
    transform: "translate(1605.5 121.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1354",
    "data-name": "Line 1354",
    d: "M32,3H0A3,3,0,0,1-3,0,3,3,0,0,1,0-3H32a3,3,0,0,1,3,3A3,3,0,0,1,32,3Z",
    transform: "translate(1621.5 105.5) rotate(90)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItemIcon);
export default __webpack_public_path__ + "static/media/addItemIcon.1275cfa8c6144e0501524e21e2067e9c.svg";
export { ForwardRef as ReactComponent };